import { genId } from "../../shared/utils"

function actionHistoryWrap(source, actionHistory, action, key){
  const newAction = {actionId: genId(), ...action}
  return {
    [key]:source,
    actionHistory: actionHistory.length > 50 ? 
    [newAction, ...actionHistory.slice(0, actionHistory.length -1)] : [newAction, ...actionHistory]
  }
}

function getActionHistoryWrapWithKey(key){
  return (s, ah, a)=> actionHistoryWrap(s, ah, a, key)
}

export { actionHistoryWrap, getActionHistoryWrapWithKey }